<template>
  <div>
    <div style="display: grid; justify-items: start; align-items: center;">
      <md-radio v-model="hasCode" :value="false">Ich habe keinen CODE erhalten.</md-radio>
      <md-radio v-model="hasCode" :value="true">Ich habe einen CODE.</md-radio>
    </div>
    <div v-if="hasCode">
      <label>
        Bitte hier deinen Code eingeben:
      </label>
      <md-field :class="{ 'md-error': codeError === true, 'md-valid': codeError === false }" class="md-xsmall-size-100 md-size-33">
        <md-input v-model="codeInputValue" style="text-align: center;"></md-input>

        <slide-y-down-transition>
          <md-icon class="error" v-show="codeError === true">close</md-icon>
        </slide-y-down-transition>
        <slide-y-down-transition>
          <md-icon class="success" v-show="codeError === false">done</md-icon>
        </slide-y-down-transition>
      </md-field>
    </div>
  </div>
</template>

<script>
import debounce from '@/utils/debounce';

export default {
  props: ['challengeId', 'initialCode'],
  data() {
    return {
      codeInputValue: this.initialCode,
      codeError: undefined,
      codeInfo: undefined,
      hasCode: false,
      debouncedCheckCode: debounce(() => this.checkCode())
    }
  },
  watch: {
    codeInputValue: 'debouncedCheckCode',
    hasCode: 'checkCode',
    codeInfo(val) {
      this.$root.$emit('code-info-updated', val);
      this.$emit('code-info-updated', val);
    }
  },
  mounted() {
    if(this.initialCode) {
      this.hasCode = true;
    }
    this.debouncedCheckCode();
  },
  methods: {
    async checkCode() {
      this.codeError = undefined;
      this.codeInfo = undefined;
      if (!this.codeInputValue || !this.hasCode) {
        return;
      }

      this.$store.dispatch("queryAPI", {
        url: `/rest/challenge/checkCode/${this.challengeId}/${this.codeInputValue}`
      })
      .then(codeInfo => {
        if (codeInfo.code.toUpperCase() === this.codeInputValue.trim().toUpperCase()) {
          this.codeError = false;
          this.codeInfo = codeInfo;
          this.$emit('code-info-updated', codeInfo);
        }
      })
      .catch(err => {
        console.log(err);
        this.codeError = true;
      })
    },
    validate() {
      if (!this.hasCode) {
        return true;
      }
      if (this.codeError) {
        this.$notify({
          timeout: 3000,
          message: "Der eingegebene Code ist ungültig.",
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger"
        });
        return false;
      }
      if (!this.codeInputValue) {
        this.codeError = true;
        this.$notify({
          timeout: 3000,
          message: "Bitte gib einen Code ein.",
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger"
        });
        return false;
      }
      if (!this.codeInfo) {
        this.$notify({
          timeout: 3000,
          message: "Der Code wird noch überprüft, bitte gedulde dich noch einige Sekunden.",
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger"
        });
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="css" scoped>
</style>
